import Rails from 'rails-ujs';
import Vue from 'vue/dist/vue.esm';
import { Carousel, Slide } from 'vue-carousel';

// スライダー画像の hidden を取り外し、表示させる関数
function showSliderContentsAfterContentLoaded(slider_contents) {
  for(let i=0; i < slider_contents.length; i++) {
    slider_contents[i].classList.remove('hidden');
  }
}

window.addEventListener('load', () => {
  const slider_contents = document.getElementsByClassName('slider_content');

  if(Rails.$('.box_content_slider')[0]){
    new Vue({
      el: '.box_content_slider',
      components: { Carousel, Slide }
    });
    if (Rails.$('.slider_content')[0]) {
      showSliderContentsAfterContentLoaded(slider_contents);
    }
  }
    showSliderContentsAfterContentLoaded(slider_contents);
});
// 買取ページの2つ目のスライダーを動作させるための関数
window.addEventListener('load', () => {
  const slider_contents = document.getElementsByClassName('slider_content1');

  if(Rails.$('.box_content_slider1')[0]){
    new Vue({
      el: '.box_content_slider1',
      components: { Carousel, Slide }
    });
    if (Rails.$('.slider_content1')[0]) {
      showSliderContentsAfterContentLoaded(slider_contents);
    }
  }
    showSliderContentsAfterContentLoaded(slider_contents);
});
